import { ChangeDetectionStrategy, Component, Provider } from "@angular/core";
import { RouterOutlet } from "@angular/router";

export function componentWithDestroyableProviders(providers: Provider[]) {

    @Component({
        providers,
        selector: 'nts-component-with-destroyable-providers',
        template: '<router-outlet></router-outlet>',
        changeDetection: ChangeDetectionStrategy.OnPush,
        standalone: true,
        imports: [
            RouterOutlet
        ]
    })
    class ModelContainerComponentFactory {


    }
    return ModelContainerComponentFactory;
}